import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/tel.png'


const _withScopeId = n => (_pushScopeId("data-v-7c383ac1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"0.8rem"} }
const _hoisted_2 = { class: "cls-flex border-btm" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "cls-con border-btm" }
const _hoisted_5 = { style: {"font-size":"0.9rem"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "联系方式", -1))
const _hoisted_7 = { class: "qr" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_image, {
        src: _ctx.data.housekeeperHeadimg,
        width: "3.5rem",
        height: "3.5rem",
        fit: "cover",
        radius: "3rem"
      }, null, 8, ["src"]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.data.housekeeperName), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, _toDisplayString(_ctx.data.housekeeperPhone||'暂无'), 1),
        _hoisted_6
      ]),
      _createElementVNode("img", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.tel_click && _ctx.tel_click(...args))),
        src: _imports_0,
        style: {"width":"2rem","height":"2rem"}
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_van_image, {
        src: _ctx.data.housekeeperQrcode,
        width: "60vw",
        height: "vw"
      }, null, 8, ["src"])
    ])
  ]))
}